import React, { useContext } from "react";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

import RegistrationFormRow from "./RegistrationFormRow";
import * as FaIcons from "react-icons/fa";

const headers = [
  { name: "createdAt", display: "Submit Date" },
  { name: "status", display: "Status" },
  { name: "learningCenterName", display: "Learning Center" },
  { name: "enrollmentType", display: "Enrollment" },
  { name: "studentFirstName", display: "Student Name" },
  { name: "age", display: "Age" },
  { name: "phone", display: "Phone" },
  { name: "primaryEmail", display: "Email" },
];

const TableHeaderItem = ({ name, display }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { sortOptions, onTableFilter } = adminRegistrationContext;

  // Safety check to ensure sortOptions[name] exists
  const sortOption = sortOptions[name] || { asc: false, desc: false };

  return (
    <th onClick={() => onTableFilter(name)}>
      <div className="wrap">
        <span>{display}</span>
        <div className="filter">
          <FaIcons.FaSortUp
            style={{
              color: sortOption.asc ? "#343434" : "white",
            }}
          />
          <FaIcons.FaSortDown
            style={{
              color: sortOption.desc ? "#343434" : "white",
            }}
          />
        </div>
      </div>
    </th>
  );
};

const RegistrationTable = ({ items }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { visibleColumns } = adminRegistrationContext;

  // Filter headers based on visibility
  const visibleHeaders = headers.filter(header => {
    // Check if column is visible in context
    if (visibleColumns && visibleColumns[header.name] === false) {
      return false;
    }
    return true;
  });

  return (
    <div className="interest-form-table">
      <div className="table-responsive">
        <table className="responsive-table" id="interest-table">
          <thead>
            <tr>
              {visibleHeaders.map((header) => (
                <TableHeaderItem key={header.name} name={header.name} display={header.display} />
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => {
              return (
                <RegistrationFormRow
                  key={item._id}
                  info={item}
                  visibleColumns={visibleColumns}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RegistrationTable;
